import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  address: undefined,
  ui: {
    isShippingAddressSelected: true,
    error: null,
    uiState: UiState.Idle
  }
};

const fetchDefaultShippingAddressRequest = draft => {
  draft.ui.uiState = UiState.Pending;
};

const fetchDefaultShippingAddressFailure = draft => {
  draft.address = null;
  draft.ui.uiState = UiState.Failure;
};

const fetchDefaultShippingAddressSuccess = (draft, action) => {
  draft.address = action.payload.address;
  draft.ui.uiState = UiState.Success;
};

const setDefaultShippingAddress = (draft, action) => {
  draft.address = action.payload.address;
};

const toggleIsShippingAddressChecked = draft => {
  draft.ui.isShippingAddressSelected = !draft.ui.isShippingAddressSelected;
};

const setIsShippingAddressSelected = draft => {
  draft.ui.isShippingAddressSelected = true;
};

const userAddressSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchDefaultShippingAddressRequest,
    fetchDefaultShippingAddressFailure,
    fetchDefaultShippingAddressSuccess,
    setDefaultShippingAddress,
    toggleIsShippingAddressChecked,
    setIsShippingAddressSelected
  }
});
export const {
  actions
} = userAddressSlice;
export const plug = {
  [stateName]: userAddressSlice.reducer
};
export default userAddressSlice.reducer;